import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import { AltProvider } from "./lib/alt";
import Resolver from "./pages/Resolver";
import BlogList from "./pages/BlogList";
import AdminApp from "./pages/admin/AdminApp";

const Site = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <AdminApp />;
  return (
    <>
      <SmoothScroll />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-white focus:px-4 focus:py-2">Skip to content</a>
      <Header />
      <div id="main">
        <Routes>
          <Route path="/category/:slug/*" element={<BlogList />} />
          <Route path="*" element={<Resolver />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AltProvider>
          <Site />
          <Toaster position="top-center" />
        </AltProvider>
      </BrowserRouter>
    </div>
  );
}
